import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-3a6by4-0' })`
    padding: ${size(0.5)} ${size(0.75)};
    background-color: var(--c-notification-bg);
    color: var(--c-notification-fg);
    font-size: ${(props) => props.theme.font.size.xsmall};
    font-weight: var(--font-weight-medium);
    border-radius: 100vmax;
    line-height: 1;
    white-space: nowrap;
`;
